import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MatSnackBar, MAT_DIALOG_DATA } from '@angular/material';
import { Patient } from 'src/app/core/models/patient/patient';
import { PatientService } from 'src/app/core/services/v2/patient.service';
import { WindowLoaderService } from 'src/app/shared/components/window-loader/window-loader.service';
import * as _ from 'lodash';
import { FormControl } from '@angular/forms';
import { UtilsService } from '../../../../core/services/v2/utils.service';
@Component({
  selector: 'app-patient-insurance-dialog',
  templateUrl: './patient-insurance-dialog.component.html',
  styleUrls: ['./patient-insurance-dialog.component.scss']
})
export class PatientInsuranceDialogComponent implements OnInit {
  lodash = _;
  pinsuranceInfo: any;
  pinsuranceFromDb: any;
  patient: Patient;
  insuranceId: number;
  physiciannpi: any;
  categories: string[] = [];
  caegoryControl: FormControl = new FormControl('');
  isBenifitsDataAvailable: boolean = false;
  constructor(
    private dialogRef: MatDialogRef<PatientInsuranceDialogComponent>,
    private patientService: PatientService,
    private loaderService: WindowLoaderService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _utils: UtilsService) {
    if (data) {
      this.patient = data.patient;
      this.physiciannpi = data.physiciannpi;
      this.insuranceId = data.insuranceId ? data.insuranceId : 0;
      this.pinsuranceInfo = data.pinsuranceInfo;
      this.isBenifitsDataAvailable = data.pinsuranceInfo ? true : false;
    }
  }

  ngOnInit() {
    this.getCoverageDetail(false)
  }

  getCoverageDetail(ishardrefresh: boolean = false) {
    if (ishardrefresh || !this.isBenifitsDataAvailable) {
      this.loaderService.blockWithLoader(this.patientService.getBenefitsFromAvaility(this.patient.id, this.physiciannpi, ishardrefresh, this.insuranceId)).subscribe(
        (pinsurance) => {
          console.log(pinsurance);
          try {
            if (pinsurance.resultStatus.isSuccess && pinsurance.resultStatus.errorCode == 0) {
              this.pinsuranceInfo = pinsurance.result.availityCoverageResponse;
              this.loadBenifitsData();
            } else {
              if (pinsurance.resultStatus.errorCode == 202 || pinsurance.resultStatus.errorCode == 204) {
                this._utils.showMessageSnackBar("Please click on refresh button", true);
              }
              else if (pinsurance.resultStatus.errorCode == 1000) {
                this._utils.showMessageSnackBar(pinsurance.resultStatus.message, true);
              }
              else if (pinsurance.resultStatus.errorCode == 400) {
                this._utils.showMessageSnackBar(pinsurance.resultStatus.message, true);
              }
              else if (pinsurance.resultStatus.errorCode == 429) {
                this._utils.showMessageSnackBar("Please after some time", true);
              } else {
                this._utils.showMessageSnackBar("Unable to get coverage details", true);
              }
              this.dialogRef.close();
            }
          } catch (e) {
            this._utils.showMessageSnackBar(e, true);
            this.dialogRef.close();
          }
        },
        (error) => {
          console.error(error);
          this.loaderService.hide();
          this.dialogRef.close();
        }
      );
    }
    else {
      this.loadBenifitsData();
    }
  }

  loadBenifitsData() {
    this.pinsuranceInfo.plans.forEach(plan => {
      plan.benefits.forEach(benefit => {
        //limitations
        if (_.has(benefit, 'limitations.noNetwork')) {
          if (benefit.limitations.noNetwork != null)
            benefit.limitations.noNetworkbyGroup = _.mapValues(_.groupBy(benefit.limitations.noNetwork, i => i.insuranceTypeCode), app => _.groupBy(app, i => i.levelCode))
        }
        if (_.has(benefit, 'limitations.inNetwork')) {
          if (benefit.limitations.inNetwork != null)
            benefit.limitations.inNetworkbyGroup = _.mapValues(_.groupBy(benefit.limitations.inNetwork, i => i.insuranceTypeCode), app => _.groupBy(app, i => i.levelCode))
        }
        if (_.has(benefit, 'limitations.outOfNetwork')) {
          if (benefit.limitations.outOfNetwork != null)
            benefit.limitations.outOfNetworkbyGroup = _.mapValues(_.groupBy(benefit.limitations.outOfNetwork, i => i.insuranceTypeCode), app => _.groupBy(app, i => i.levelCode))
        }
        if (_.has(benefit, 'limitations.notApplicableNetwork')) {
          if (benefit.limitations.notApplicableNetwork != null)
            benefit.limitations.notApplicableNetworkbyGroup = _.mapValues(_.groupBy(benefit.limitations.notApplicableNetwork, i => i.insuranceTypeCode), app => _.groupBy(app, i => i.levelCode))
        }


        //amounts.coPayment
        if (_.has(benefit, 'amounts.coPayment.noNetwork')) {
          if (benefit.amounts.coPayment.noNetwork != null)
            benefit.amounts.coPayment.noNetworkbyGroup = _.mapValues(_.groupBy(benefit.amounts.coPayment.noNetwork, i => i.insuranceTypeCode), app => _.groupBy(app, i => i.levelCode))
        }
        if (_.has(benefit, 'amounts.coPayment.inNetwork')) {
          if (benefit.amounts.coPayment.inNetwork != null)
            benefit.amounts.coPayment.inNetworkbyGroup = _.mapValues(_.groupBy(benefit.amounts.coPayment.inNetwork, i => i.insuranceTypeCode), app => _.groupBy(app, i => i.levelCode))
        }
        if (_.has(benefit, 'amounts.coPayment.outOfNetwork')) {
          if (benefit.amounts.coPayment.outOfNetwork != null)
            benefit.amounts.coPayment.outOfNetworkbyGroup = _.mapValues(_.groupBy(benefit.amounts.coPayment.outOfNetwork, i => i.insuranceTypeCode), app => _.groupBy(app, i => i.levelCode))
        }
        if (_.has(benefit, 'amounts.coPayment.notApplicableNetwork')) {
          if (benefit.amounts.coPayment.notApplicableNetwork != null)
            benefit.amounts.coPayment.notApplicableNetworkbyGroup = _.mapValues(_.groupBy(benefit.amounts.coPayment.notApplicableNetwork, i => i.insuranceTypeCode), app => _.groupBy(app, i => i.levelCode))
        }
        //coInsurance
        if (_.has(benefit, 'amounts.coInsurance.noNetwork')) {
          if (benefit.amounts.coInsurance.noNetwork != null)
            benefit.amounts.coInsurance.noNetworkbyGroup = _.mapValues(_.groupBy(benefit.amounts.coInsurance.noNetwork, i => i.insuranceTypeCode), app => _.groupBy(app, i => i.levelCode))
        }
        if (_.has(benefit, 'amounts.coInsurance.inNetwork')) {
          if (benefit.amounts.coInsurance.inNetwork != null)
            benefit.amounts.coInsurance.inNetworkbyGroup = _.mapValues(_.groupBy(benefit.amounts.coInsurance.inNetwork, i => i.insuranceTypeCode), app => _.groupBy(app, i => i.levelCode))
        }
        if (_.has(benefit, 'amounts.coInsurance.outOfNetwork')) {
          if (benefit.amounts.coInsurance.outOfNetwork != null)
            benefit.amounts.coInsurance.outOfNetworkbyGroup = _.mapValues(_.groupBy(benefit.amounts.coInsurance.outOfNetwork, i => i.insuranceTypeCode), app => _.groupBy(app, i => i.levelCode))
        }
        if (_.has(benefit, 'amounts.coInsurance.notApplicableNetwork')) {
          if (benefit.amounts.coInsurance.notApplicableNetwork != null)
            benefit.amounts.coInsurance.notApplicableNetworkbyGroup = _.mapValues(_.groupBy(benefit.amounts.coInsurance.notApplicableNetwork, i => i.insuranceTypeCode), app => _.groupBy(app, i => i.levelCode))
        }
        //deductable notApplicableNetwork
        if (_.has(benefit, 'amounts.deductibles.noNetwork')) {
          if (benefit.amounts.deductibles.noNetwork != null)
            benefit.amounts.deductibles.noNetworkbyGroup = _.mapValues(_.groupBy(benefit.amounts.deductibles.noNetwork, i => i.insuranceTypeCode), app => _.groupBy(app, i => i.levelCode))
        }
        if (_.has(benefit, 'amounts.deductibles.inNetwork')) {
          if (benefit.amounts.deductibles.inNetwork != null)
            benefit.amounts.deductibles.inNetworkbyGroup = _.mapValues(_.groupBy(benefit.amounts.deductibles.inNetwork, i => i.insuranceTypeCode), app => _.groupBy(app, i => i.levelCode))
        }
        if (_.has(benefit, 'amounts.deductibles.outOfNetwork')) {
          if (benefit.amounts.deductibles.outOfNetwork != null)
            benefit.amounts.deductibles.outOfNetworkbyGroup = _.mapValues(_.groupBy(benefit.amounts.deductibles.outOfNetwork, i => i.insuranceTypeCode), app => _.groupBy(app, i => i.levelCode))
        }
        if (_.has(benefit, 'amounts.deductibles.notApplicableNetwork')) {
          if (benefit.amounts.deductibles.notApplicableNetwork != null)
            benefit.amounts.deductibles.notApplicableNetworkbyGroup = _.mapValues(_.groupBy(benefit.amounts.deductibles.notApplicableNetwork, i => i.insuranceTypeCode), app => _.groupBy(app, i => i.levelCode))
        }


        //outOfPocket
        if (_.has(benefit, 'amounts.outOfPocket.noNetwork')) {
          if (benefit.amounts.outOfPocket.noNetwork != null)
            benefit.amounts.outOfPocket.noNetworkbyGroup = _.mapValues(_.groupBy(benefit.amounts.outOfPocket.noNetwork, i => i.insuranceTypeCode), app => _.groupBy(app, i => i.levelCode))
        }
        if (_.has(benefit, 'amounts.outOfPocket.inNetwork')) {
          if (benefit.amounts.outOfPocket.inNetwork != null)
            benefit.amounts.outOfPocket.inNetworkbyGroup = _.mapValues(_.groupBy(benefit.amounts.outOfPocket.inNetwork, i => i.insuranceTypeCode), app => _.groupBy(app, i => i.levelCode))
        }
        if (_.has(benefit, 'amounts.outOfPocket.outOfNetwork')) {
          if (benefit.amounts.outOfPocket.outOfNetwork != null)
            benefit.amounts.outOfPocket.outOfNetworkbyGroup = _.mapValues(_.groupBy(benefit.amounts.outOfPocket.outOfNetwork, i => i.insuranceTypeCode), app => _.groupBy(app, i => i.levelCode))
        }
        if (_.has(benefit, 'amounts.outOfPocket.notApplicableNetwork')) {
          if (benefit.amounts.outOfPocket.notApplicableNetwork != null)
            benefit.amounts.outOfPocket.notApplicableNetworkbyGroup = _.mapValues(_.groupBy(benefit.amounts.outOfPocket.notApplicableNetwork, i => i.insuranceTypeCode), app => _.groupBy(app, i => i.levelCode))
        }
      });
      console.log("patientInsurance", this.pinsuranceInfo.plans);
    });
    this.categories = this.pinsuranceInfo.plans[0].benefits.map((ben) => ben.name);
    this.pinsuranceFromDb = _.cloneDeep(this.pinsuranceInfo);
  }

  getAvailityErrorMessage(errorString: string): string {
    try {
      let errorObj = JSON.parse(errorString);
      if (typeof errorObj === 'object') {
        if (errorObj && errorObj.errors) {
          return errorObj.errors[0].errorMessage;
        }
      }
      else {
        return errorString;
      }
    } catch (e) {
      return errorString;
    }

  }

  onCategoryChange(event: any) {
    this.pinsuranceInfo = _.cloneDeep(this.pinsuranceFromDb);
    if (event.target.value) {
      this.pinsuranceInfo.plans[0].benefits = this.pinsuranceInfo.plans[0].benefits.filter(x => x.name == event.target.value);
    }
  }
}
